const routes = [
    {
        path: "/conservatory/application/quotas",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "conservatoryapplicationquota_index"
        }
    }
];

export default routes;
